import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Route, BrowserRouter as Router, Routes} from 'react-router-dom'
import ComingSoon from './pages/ComingSoonPage.pages';

// const router = createBrowserRouter(
//   createRoutesFromElements(
//     <Route path='/' element={<App/>}>
//       <Route index element={<HomePage />} />
//       <Route path='about' element={<AboutPage/>}/>
//     </Route>
//   )
// )

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <RouterProvider router={router}/>
  <Router>
    <Routes>
      <Route path="/*" element={<App/>}/>
      <Route path="/game" element={<ComingSoon/>} />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
